
<!-- DOMAIN CTAs -->
<span class="cmp-ctas" :class="{ mobile, desktop: !mobile }">
  <div
    v-if="loading"
    class="text-center"
    :class="{ 'full-width': mobile, 'q-mr-md': !mobile }"
  >
    <ws-spinner
      :height="mobile ? '24px' : undefined"
      :width="mobile ? '64px' : undefined"
      :color="inCart ? 'dark' : !inCart && isTheme(Theme.LOOPIA) ? 'white' : undefined"
    />
  </div>

  <ws-button
    v-else-if="workflow === CTAS_WORKFLOW.BUY"
    :type="WsButtonEnum.Type.PRIMARY"
    :size="WsButtonEnum.Size.XL"
    class="cy-buy-domain"
    :class="{
      error,
      mobile,
    }"
    icon="cart"
    @click="buy()"
  >
    <span v-if="!mobile" class="block">{{
      $t(
        error
          ? 'domain_checker.buy_domain.failed'
          : 'domain_checker.buy_domain.implicit'
      )
    }}</span>
  </ws-button>

  <!-- REMOVE FROM CART button -->
  <ws-button
    v-else-if="workflow === CTAS_WORKFLOW.IN_CART"
    class="remove"
    :class="{
      error,
      mobile,
    }"
    icon="trash"
    @click="bundle ? removeBundle() : removeDomain()"
  >
    <span v-if="!mobile" class="block">{{
      $t(
        `domain_checker.${transferInCart ? 'transfer.' : ''}remove_domain.${
          error ? 'failed' : 'implicit'
        }`
      )
    }}</span>
  </ws-button>

  <!-- TODO: WATCH DOMAIN -->
  <!--<ws-button
    v-if="
      !get(domain, 'availableForPurchase', false) &&
        !get(domain, 'error', null)
    "
    class="mobile-smaller"
    :class="{ error: false, mobile }"
    icon="mail"
    @click="showTransfer = !showTransfer"
    >{{
     $t(mobile ? 'domain_checker.watch_domain.button_text_mobile' : 'domain_checker.watch_domain.button_text_desktop')
    }}
  </ws-button>-->

  <!-- IS YOURS -->
  <span v-else-if="workflow === CTAS_WORKFLOW.YOURS">
    <ws-button class="mobile-smaller" icon="info">{{
      $t(
        mobile
          ? 'domain_checker.i_am_owner.label_mobile'
          : 'domain_checker.i_am_owner.label'
      )
    }}
    </ws-button>
    <ws-tooltip :delay="500">{{ $t('domain_checker.i_am_owner.tooltip') }}</ws-tooltip>
  </span>

  <!-- TAKEN -->
  <span v-else-if="workflow === CTAS_WORKFLOW.TAKEN">
    <ws-button
      class="mobile-smaller without-separator"
      icon="alert_triangle"
      :label="$t(
        mobile
          ? 'domain_checker.domain_is_taken.label_mobile'
          : 'domain_checker.domain_is_taken.label'
      )"
    />
    <ws-tooltip :delay="500">{{ $t('domain_checker.domain_is_taken.tooltip') }}</ws-tooltip>
  </span>

  <!-- MY DOMAIN - transfer screen -->
  <span
    v-else-if="workflow === CTAS_WORKFLOW.MY_DOMAIN"
    ref="myDomain"
    class="my-domain"
    :class="{ active: isMyDomainPopup }"
  >
    <ws-button
      ref="myDomainButton"
      class="mobile-smaller"
      :class="{ mobile }"
      icon="domain"
    >{{
      $t(
        mobile
          ? 'domain_checker.my_domain.btn_mobile'
          : 'domain_checker.my_domain.btn_desktop'
      )
    }}</ws-button>

    <domain-popup
      ref="domainPopup"
      v-model="domain"
      @show="isMyDomainPopup = true"
      @hide="isMyDomainPopup = false"
    >
      <domain-popup-transfer
        :domain="domain"
        :should-login="shouldLogin"
        @hide-popup="hidePopup"
      />
    </domain-popup>
  </span>
</span>
